export default __webpack_public_path__ + "static/media/logo-hd-platform.4e60f9bb.svg";